// 上游半流程相关接口
import { api } from '@/utils/axios'

/** 授权协议项（与普通 H5 申请/授权页 FormResultVO.protocols 同结构） */
export interface HalfProcessProtocol {
  id: string
  name: string
  /** 1-卫付通默认授权协议，其余为机构相关协议 */
  protocolType: number
}

/** 半流程申请页上下文 */
export interface HalfProcessContext {
  serialNo: string
  productId: number
  productName: string
  companyName: string
  productLogo: string
  productPrice?: number
  /** 协议列表，与 status/result、表单匹配结果一致 */
  protocols?: HalfProcessProtocol[]
}

const halfProcessApi = {
  /** 获取半流程申请页上下文（含与普通授权页同格式的协议） */
  getContext(serialNo: string) {
    return api.get<HalfProcessContext>('/api/halfProcess/context', { serialNo }, {
      // mock: true
    })
  },
}

export default halfProcessApi
